<div class="add-area-subscription-page-container container" fxLayout="column" fxLayoutGap="15px">
  <div class="list-container container">
    <mtn-geographic-area-selection-list #areas [initialCbsas]="existingCbsaFips" [initialStates]="existingStateFips"
                                        *ngIf="isSelectionsLoaded"
                                        (selectionChange)="recordSelections($event)"></mtn-geographic-area-selection-list>
    <mtn-spinner [size]="SpinnerSize.MEDIUM" [on]="!areas || areas.isLoading"></mtn-spinner>
  </div>
</div>
